import type { IconData } from '@stacksjs/iconify-core'

export const contentFile: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M8.5 0H1v16h14V6.5H8.5z\"/><path fill=\"currentColor\" d=\"M10 0v5h5a5 5 0 0 0-5-5\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default contentFile
